module.exports = __webpack_public_path__ + "static/home-banner-01-0c7f273d26ee9662c0389632a7d594d9.jpg";